export default "__VITE_ASSET__nTDwAX78__"